import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServiceParkingRates } from '../../api/parking-service.ts';
import { UpdateParkingServiceParkingRatesRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceParkingRates(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceParkingRates>>,
  Error,
  UpdateParkingServiceParkingRatesRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceParkingRates,
  });
}
